import {
  Component,
  Input,
  ViewChild,
  AfterViewInit,
  NgModule,
  Compiler,
  ViewContainerRef,
  NgModuleRef,
  Injector,
  ComponentRef,
} from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';

@Component({
  selector: 'wp-conteudo',
  template: `<div #vc></div>`,
  styleUrls: ['./wp-conteudo.component.scss'],
})
export class WpConteudoComponent implements AfterViewInit {

  galerias = {};
  @ViewChild('vc', { read: ViewContainerRef }) vc: ViewContainerRef;
  private cmpRef: ComponentRef<any>;

  @Input() conteudo;
  contexto = '';

  constructor(private compiler: Compiler,
    private injector: Injector,
    private moduleRef: NgModuleRef<any>,
  ) { }

  ngAfterViewInit() {
    const template = this.renderizaGalerias(this.conteudo);
    this.createComponentFromRaw(template);
  }

  private createComponentFromRaw(template: string) {
    const tmpCmp = Component({ template })(class {
      ngOnInit() {}
    });

    const tmpModule = NgModule({
      declarations: [tmpCmp],
      imports: [SharedModule],
    })(class { });

    this.compiler.compileModuleAndAllComponentsAsync(tmpModule)
      .then((factories) => {
        const f = factories.componentFactories[factories.componentFactories.length - 1];
        this.cmpRef = f.create(this.injector, [], null, this.moduleRef);
        this.cmpRef.instance.galerias = this.galerias;
        this.vc.insert(this.cmpRef.hostView);
      });
  }

  renderizaGalerias(str) {
    const container = document.createElement('div');
    container.innerHTML = str;
    const estilos = container.querySelectorAll('style');
    const galeriasDOM = container.querySelectorAll('.gallery');

    for (let i = estilos.length - 1; i >= 0; i--) {
      estilos[i].parentNode.removeChild(estilos[i]);
    }

    // no IE não existe um forEach ou map para DOMList.
    for (let i = galeriasDOM.length - 1; i >= 0; i--) {
      const galeria = galeriasDOM[i];
      const elementoItemGaleria = galeria.querySelectorAll('.gallery-item');
      const itensGaleria = [];

      for (let j = 0; j < elementoItemGaleria.length; j++) {
        const itemGaleria = elementoItemGaleria[j];
        const srcItemImagem = itemGaleria.querySelector('img').src;
        const legenda = itemGaleria.querySelector('.gallery-caption');
        itensGaleria.push({
          src: srcItemImagem,
          title: legenda && legenda.textContent.trim(),
        });
      }
      this.galerias[galeria.id] = itensGaleria;

      galeria.parentNode.insertBefore(
        // carrossel,
        document.createTextNode(`[carrossel id="${galeria.id}"]`),
        galeria,
      );
      galeria.parentNode.removeChild(galeria);
    }

    const output = container.innerHTML.replace('\n', '').replace(/\[carrossel id="(gallery-\d{1,})"\]/g, (element, group, pos) => {
      return `<carrossel [itens]="galerias['${group}']"></carrossel>`;
    });
    return output;
  }
}
